import i18n from '@/i18n';

export default {
  methods: {
    t(...args) {
      return i18n.t(...args);
    },
  },
};
